import React, { useContext } from 'react'
import "./morePage.css"
import { Link, useNavigate } from 'react-router-dom'
import { CartContext } from '../../Context/CartContext.js';
import { UserContext } from '../../Context/UserContext.js';
import { logOut } from '../../Utilities/logOut.js';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';








export default function MorePage() {

   const navigate = useNavigate();
   const totalUserInfo = useContext(UserContext);
   const { itemCount, setItemCount, getLoggedCart } = useContext(CartContext);

   const services = [
      // { name: "شحن محفظتى", url: "#", icon: <i className="fa-solid fa-wallet"></i>, disabled: true },
      // { name: "روشتاتى ", url: "/prescription", icon: <i className="fa-solid fa-file-waveform"></i>, disabled: true },
      // { name: "التغطية التأمينية", url: "#", icon: <i className="fa-solid fa-umbrella"></i> },
      // { name: "عروضى المفضلة", url: "#", icon: <i className="fa-solid fa-heart-pulse"></i> },
      // { name: "مشترياتى", url: "/allOrderLoggedUser", icon: <i className="fa-solid fa-bag-shopping"></i> },
      // { name: "اللغة ", click: "", icon: <i className="fa-solid fa-earth-americas"></i> },
      { name: "تعديل ملفى الطبى", url: "/SickHistory", icon: <i className="fa-solid fa-user-doctor"></i> },
      { name: "تعديل بياناتى", url: "/updateUserProfile", icon: <i className="fa-solid fa-user-pen"></i> },
      { name: "مقدمى الخدمات ", url: "/price", icon: <i className="fa-solid fa-briefcase-medical"></i> },
      { name: "تغيير كلمة المرور", url: "/ChangePassword", icon: <i className="fa-solid fa-lock"></i> },
      { name: "أتصل بنا", url: "/contact", icon: <i className="fa-solid fa-phone"></i> },
      { name: "خروج", click: handleLogOut, icon: <i className="fa-solid fa-right-from-bracket"></i> }
   ]




   //& Handle Log Out :
   function handleLogOut() {
      logOut(navigate, totalUserInfo);
   }


   return (
      <>
         <div className="container morePage-container">
            <CustomTitle title="الاعدادات" />

            {/* <div className='account-card d-flex justify-content-center align-item-center text-center'>
               <div className='bg-light  rounded-start-pill'>
                  <p className='m-0 fw-bold main-color' dir='rtl'>00.00 جنية</p>
                  <p className='m-0'>المحفظة الأضافية</p>
               </div>
               <div className='bg-light rounded-end-pill '>
                  <p className='m-0 fw-bold main-color' dir='rtl'>00.00 جنية</p>
                  <p className='m-0'>المحفظةالأساسية</p>
               </div>
            </div> */}

            {/* 
            <div className='text-right px-3'>
               <Link to="/SickHistory" className='btn btn-secondary w-100'> تعديل ملفى الطبى</Link>
            </div>
            <div className='text-right px-3 mb-1'>
               <Link to={`/updateUserProfile`} className='btn btn-secondary  w-100 mt-2' >تعديل بياناتى</Link>
         </div> */}
            {/* <p className='my-2'> أحجز العادية  |    1440</p> */}

            <div className="row btn-group m-auto d-flex justify-content-center" dir='rtl'>
               {services.map((ele, index) =>
                  <div key={index} className="col-12 col-md-4 m-auto" >
                     <div className='p-1' disabled={ele.disabled ? true : false} >
                        <Link to={ele.url ? ele.url : ""} onClick={ele.click ? () => { ele.click() } : ""} className='btn btn-secondary w-100 border-0'  >
                           <div className='d-flex justify-content-between align-items-center'>
                              <span className='text-box-more'>{ele.name}</span>
                              {ele.icon}
                           </div>
                        </Link>
                     </div>
                  </div>
               )}
            </div>
         </div >
      </>
   )
}
